import { render, staticRenderFns } from "./KeyPerformanceArea.vue?vue&type=template&id=c70c87d4"
import script from "./KeyPerformanceArea.vue?vue&type=script&lang=js"
export * from "./KeyPerformanceArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports